import { ApplicationDispatcher } from '~/flux/dispatchers';

const apiUrl = process.env.DT_API_ADDRESS || 'http://localhost:3001';

const graphqlClient = {
  request: async <T>(
    operationName: string,
    query: string,
    variables: Record<string, any>
  ): Promise<T> => {
    const response = await fetch(`${apiUrl}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const result = await response.json();

    if (result.errors) {
      if (result.errors[0].message === 'API call is locked') {
        ApplicationDispatcher.handleAppAction({
          actionType: ApplicationDispatcher.NO_REDLOCK,
          lock_name: operationName,
        });
      }

      throw result.errors[0];
    }

    const data = result.data[operationName];
    return data;
  },
};
export default graphqlClient;
